import React from 'react';
import './ProductStory.css';

export default function ProductStory({ id }) {
  return (
    <section className="product-story" id={id}>
      <div className="product-story-container">
        <div className="bar-compare-header">
          <h2 className="product-story-title">关于电牙</h2>
        </div>

        <p className="product-story-desc">
          电牙AI是一家由多位连续创业者创立的AI模型和智能硬件公司。产研团队背景覆盖自然语言处理、ASR、嵌入式、双足机器人、IoT等，供应链团队在小米生态链公司、科大讯飞等公司完成过多个产品线的量产交付。
        </p>
        <p className="product-story-desc">
          电牙自主研发了前沿的ASR模型，同时为B端客户（若干细分行业龙头公司）和C端客户，提供可靠的语音转文字、同传翻译、摘要总结、text2sql等服务。
        </p>
        <p className="product-story-desc">
          电牙AI崇尚极简、性能和生活美学，期待用底层技术的最新突破，改变我们的工作和生活：让工作效果更好效率更高，让生活多一些轻松和快乐。
        </p>
      </div>
    </section>
  );
} 